import { makeStyles, useTheme } from '@material-ui/core';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import * as React from 'react';
const useStyles = makeStyles((theme) => ({
  root: {
    userSelect: 'none',
    width: '1em',
    height: '1em',
    display: 'inline-block',
    fill: 'currentColor',
    flexShrink: 0,
    transition: theme.transitions.create('fill', {
      duration: theme.transitions.duration.shorter,
    }),
  },
}));

function SvgBasicDescription({ svgRef, ...props }) {
  const classes = useStyles();
  const theme = useTheme();
  const { color, className } = props;
  return (
    <svg
      {...props}
      viewBox="0 0 16 16"
      className={classnames(classes.root, className)}
      color={theme.colors[color] ?? color}
      ref={svgRef}
    >
      <path
        d="M12.5 1.25c.97 0 1.75.78 1.75 1.75v10c0 .97-.78 1.75-1.75 1.75h-9c-.97 0-1.75-.78-1.75-1.75V3c0-.97.78-1.75 1.75-1.75h9zm0 1.5h-9a.25.25 0 00-.25.25v10c0 .14.11.25.25.25h9c.14 0 .25-.11.25-.25V3a.25.25 0 00-.25-.25zm-4 4.5a.75.75 0 010 1.5h-3a.75.75 0 010-1.5zm2-3a.75.75 0 110 1.5h-5a.75.75 0 010-1.5z"
        fillRule="evenodd"
      />
    </svg>
  );
}

SvgBasicDescription.propTypes = {
  svgRef: PropTypes.any,
  className: PropTypes.string,
  color: PropTypes.string,
  fontSize: PropTypes.any,
};
SvgBasicDescription.defaultProps = {
  svgRef: undefined,
  className: undefined,
  color: undefined,
  fontSize: 16,
};
const ForwardRef = React.forwardRef((props, ref) => (
  <SvgBasicDescription svgRef={ref} {...props} />
));
export default ForwardRef;
